export const GET_DASHBOARD_ALL_FOLLOWINGS = 'GET_DASHBOARD_ALL_FOLLOWINGS' as const;
export const GET_DASHBOARD_ALL_FOLLOWINGS_PENDING = 'GET_DASHBOARD_ALL_FOLLOWINGS_PENDING' as const;
export const GET_DASHBOARD_ALL_FOLLOWINGS_FULFILLED = 'GET_DASHBOARD_ALL_FOLLOWINGS_FULFILLED' as const;
export const GET_DASHBOARD_ALL_FOLLOWINGS_REJECTED = 'GET_DASHBOARD_ALL_FOLLOWINGS_REJECTED' as const;
